import React from 'react';
import { ReactComponent as SearchIcon } from 'assets/icon-search.svg';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const TopbarSidebarButton = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleClick = () => {
    history.push('/searchAll/results');
  };

  if (window.location.pathname === '/searchAll/results') {
    return null;
  }

  return (
    <div
      className="topbar__search__btn"
      onClick={() => handleClick()}
      aria-hidden="true"
      role="button"
    >
      <SearchIcon />
      <span className="topbar__search__text">{t('top_bar_search_button_text')}</span>
    </div>
  );
};

export default TopbarSidebarButton;
